import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import PrimaryButton from "../components/PrimaryButton";
import DotMenu from "../components/DotMenu";
import vid from "../assets/images/Rectangle 18156.png";
import FileCard from "../components/FileCard";
import MainModal from "../components/MainModal";
import PaymentHistory from "../components/PaymentHistory";
import SpecificFileVideoView from "../components/SpecificFileVideoView";
import SpecificFileAudioView from "../components/SpecificFileAudioView";
import UploadFileModal, { UploadFileModalStep2, UploadFileModalStep3 } from "../components/UploadFileModal";
import TranslateToModal from "../components/TranslateToModal";
import AdjustmentModal from "../components/AdjustmentModal";
import ReviewAndconfirmModal from "../components/ReviewAndconfirmModal";
import EditDetailsModal from "../components/EditDetailsModal";
import { BigPlusIcon, CheckCircleIcon, EditIcon, TranslateIcon, TrashIcon, UserSettingsIcon, WalletIcon } from "../assets/icons/Icons";
import pathnames from "../routes/index.route";
import { useRedirect } from "../hooks/useRedirect";
import { CardSkeletonLoader } from "../components/CardSkeletonLoader";

const options = [
  { label: "Select many files", icon: CheckCircleIcon },
  { label: "Edit information", icon: EditIcon },
  { label: "Add file to group", icon: BigPlusIcon },
  { label: "See payment history", icon: WalletIcon },
  { label: "Manage access", icon: UserSettingsIcon },
  { label: "Delete group", icon: TrashIcon, color: "red" },
];

const SpecificFileGroup = () => {
  const [option, setOption] = useState<string>("");
  const [showTranslate, setShowTranslate] = useState<boolean>(false);
  const [showAdjustment, setShowAdjustment] = useState<boolean>(false);
  const [showReview, setShowReview] = useState<boolean>(false);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [showChooseG, setShowChooseG] = useState<boolean>(false);
  const redirect = useRedirect();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);
  const translateModalNext = () => {
    setShowTranslate(false);
    setShowAdjustment(true);
  }
  const adjustmentModalNext = () => {
    setShowAdjustment(false);
    setShowReview(true);
  }
  const adjustmentModalPrev = () => {
    setShowAdjustment(false);
    setShowTranslate(true);
  }
  const reviewModalPrev = () => {
    setShowReview(false);
    setShowAdjustment(true);
  }
  const editDetailsModalNext = () => {
    setOption("");
    setShowTranslate(true);
  }

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[7px]">
          <h1 onClick={() => redirect(pathnames.content)} className="text-[#9392A2] text-xs font-medium cursor-pointer tracking-tight">Files</h1>
          <IoIosArrowForward className="text-[#9392A2] text-base font-medium" />
          <h1 className="text-[#9392A2] text-xs font-medium cursor-pointer tracking-tight">Game video</h1>
        </div>
        <div className="flex items-center gap-2">
          <PrimaryButton onClick={() => setShowTranslate(true)} label="Translate" black className="rounded-full px-4 py-1.5" labelStyle="text-sm font-medium" />
          <PrimaryButton label="Schedule multipost" className="rounded-full px-4 py-1.5" labelStyle="text-sm font-medium" />
          <DotMenu setSelected={setOption} options={options} type="circle" />
        </div>
      </div>
      <div className="mt-3 flex items-center gap-3.5">
        <img src={vid} className="w-14 h-14 rounded-md" alt="user" />
        <div>
          <h1 className="text-[#0F0C18] text-[27px] font-medium tracking-tight">Game video</h1>
          <div className="flex items-center gap-1">
            <TranslateIcon />
            <h1 className="text-[#9392A2] text-xs font-medium">13 translations</h1>
          </div>
        </div>
      </div>
      <p className="text-[#9392A2] mt-10 mb-3 text-xs font-medium tracking-tight">6 file groups</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
            [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
            [...Array(6)].map((_, index) => <FileCard key={index} setSelected={setOption} />)
        }
      </div>
      {
        option === options[3].label &&
        <MainModal
          label="Payment history"
          setShowOption={setOption}
        >
          <PaymentHistory />
        </MainModal>
      }
      {
        option === "1" &&
        <MainModal
          label="Game video"
          setShowOption={setOption}
          width="560px"
        >
          <SpecificFileVideoView />
        </MainModal>
      }
      {
        option === "2" &&
        <MainModal
          label="Game Audio"
          setShowOption={setOption}
          width="560px"
        >
          <SpecificFileAudioView />
        </MainModal>
      }
      {
        option === options[2].label &&
        <MainModal
          subLabel="Step 1 of 3"
          setShowOption={setOption}
        >
          <UploadFileModal showNext={() => {
            setOption("")
            setShowPreview(true)
          }} />
        </MainModal>
      }
      {
        showPreview &&
        <MainModal
          subLabel="Step 2 of 3"
          setShowModal={setShowPreview}
        >
          <UploadFileModalStep2 showNext={() => {
            setShowPreview(false)
            setShowChooseG(true)
          }} />
        </MainModal>
      }
      {
        showChooseG &&
        <MainModal
          subLabel="Step 3 of 3"
          setShowModal={setShowChooseG}
        >
          <UploadFileModalStep3 showPrev={() => {
            setShowChooseG(false)
            setShowPreview(true)
          }} />
        </MainModal>
      }
      {
        showTranslate &&
        <MainModal
          label="Translate to"
          setShowModal={setShowTranslate}
        >
          <TranslateToModal showNext={translateModalNext} />
        </MainModal>
      }
      {
        showAdjustment &&
        <MainModal
          label="Adjustment"
          setShowModal={setShowAdjustment}
        >
          <AdjustmentModal showPrev={adjustmentModalPrev} showNext={adjustmentModalNext} />
        </MainModal>
      }
      {
        showReview &&
        <MainModal
          label="Review & confirm"
          setShowModal={setShowReview}
        >
          <ReviewAndconfirmModal showPrev={reviewModalPrev} />
        </MainModal>
      }
      {
        option === "Edit details" &&
        <MainModal
          label="Edit details"
          setShowOption={setOption}
        >
          <EditDetailsModal showNext={editDetailsModalNext} />
        </MainModal>
      }
    </>
  );
};

export default SpecificFileGroup;